import React from "react";
import { ProducerAccountListLoaderTemplate } from "themes/administration/producer/components";

function ProducerAccountListLoader(props) {
    return <ProducerAccountListLoaderTemplate {...props} />;
}

export default ProducerAccountListLoader;
